/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIRequestAutocompleteSuggestion
 */
export interface APIRequestAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIRequestAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestAutocompleteSuggestion
     */
    certificate?: string;
    /**
     * 
     * @type {number}
     * @memberof APIRequestAutocompleteSuggestion
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIRequestAutocompleteSuggestion
     */
    statusDisplay?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestAutocompleteSuggestion
     */
    contactName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestAutocompleteSuggestion
     */
    articleNumbers?: Array<string>;
}

/**
 * Check if a given object implements the APIRequestAutocompleteSuggestion interface.
 */
export function instanceOfAPIRequestAutocompleteSuggestion(value: object): value is APIRequestAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIRequestAutocompleteSuggestionFromJSON(json: any): APIRequestAutocompleteSuggestion {
    return APIRequestAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIRequestAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'certificate': json['certificate'] == null ? undefined : json['certificate'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusDisplay': json['status_display'] == null ? undefined : json['status_display'],
        'contactName': json['contact_name'] == null ? undefined : json['contact_name'],
        'articleNumbers': json['article_numbers'] == null ? undefined : json['article_numbers'],
    };
}

export function APIRequestAutocompleteSuggestionToJSON(value?: APIRequestAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'certificate': value['certificate'],
        'status': value['status'],
        'status_display': value['statusDisplay'],
        'contact_name': value['contactName'],
        'article_numbers': value['articleNumbers'],
    };
}

